<script setup>
import { computed } from 'vue';
import Navbar from '@/components/navbar/Navbar.vue';
import NavbarMobile from '@/components/navbar/NavbarMobile.vue';
import EmailVerificationBanner from '@/components/commons/EmailVerificationBanner.vue';
import { useRoute } from 'vue-router';
const route = useRoute();
const hideNavbar = computed(() => route.meta.hideNavbar);

const screenSize = computed(() => window.innerWidth);
</script>

<template>
    <div class="min-h-screen flex flex-col overflow-hidden">
        <main class="flex-1 flex flex-col">
            <!-- Desktop layout -->
            <div v-if="screenSize >= 768">
                <div  v-if="!hideNavbar" class="w-full top-0 sticky z-[9999]">
                    <Navbar />
                    <EmailVerificationBanner />
                </div>
                <div class="flex-1" :class="{'h-[calc(100vh-64px)] overflow-y-auto': !hideNavbar}">
                    <router-view />
                </div>
            </div>
            <!-- Mobile layout -->
             <div v-else>
                <NavbarMobile v-if="!hideNavbar">
                    <EmailVerificationBanner />
                    <div class="flex-1">
                        <router-view />
                    </div>
                </NavbarMobile>
                <div class="flex-1" v-else>
                    <router-view />
                </div>
             </div>
        </main>
    </div>
</template>
